// THE FIGURES COUNT UP (21 Sep 2026, Josh): when the proof comes into view, each figure
// climbs to its number over about a second, one a beat after the other, then settles on the
// exact words it was given. A figure with a number in it (99.4%, 500+) keeps whatever sits
// before and after the number. A figure in words ("Over a million") is left exactly as
// written climbs in hundreds of thousands to a million, then the words return (Josh, 22 Sep). The page carries the final words from the
// first paint; the script only ever changes them while the count runs, and while it runs the
// accessible name stays the final statement. Nothing moves for anyone who has asked for
// reduced motion, and nothing moves twice.
(function () {
  if (!('IntersectionObserver' in window) || !window.requestAnimationFrame) return;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var figures = document.querySelectorAll('[data-count]');
  if (!figures.length || reduced) return;

  function parse(text) {
    var m = text.match(/(\d[\d,]*\.?\d*)/);
    if (m) {
      var digits = m[1].replace(/,/g, '');
      return { target: parseFloat(digits), decimals: (digits.split('.')[1] || '').length, before: text.slice(0, m.index), after: text.slice(m.index + m[1].length) };
    }
    // "Over a million" climbs in hundreds of thousands, 100,000 to 1,000,000, then the words
    // return (Josh, 22 Sep).
    if (/million/i.test(text)) return { target: 1000000, decimals: 0, before: '', after: '', coarse: 100000 };
    return null;
  }
  function format(n, decimals) {
    return n.toLocaleString('en-GB', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
  }
  function run(el) {
    var words = el.textContent.trim(), spec = parse(words);
    if (!spec) return;
    var start = null, duration = 1100;
    el.style.fontVariantNumeric = 'tabular-nums';
    el.setAttribute('aria-label', words);
    el.textContent = spec.before + format(0, spec.decimals) + spec.after;
    function step(now) {
      if (start === null) start = now;
      var p = Math.min((now - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      var value = spec.target * eased;
      if (spec.coarse) value = Math.max(spec.coarse, Math.round(value / spec.coarse) * spec.coarse);
      if (p < 1) {
        el.textContent = spec.before + format(value, spec.decimals) + spec.after;
        requestAnimationFrame(step);
      } else {
        el.textContent = words;
        el.removeAttribute('aria-label');
        el.style.fontVariantNumeric = '';
      }
    }
    requestAnimationFrame(step);
  }

  var seen = false;
  var io = new IntersectionObserver(function (entries) {
    if (seen || !entries.some(function (e) { return e.isIntersecting; })) return;
    seen = true;
    figures.forEach(function (el) { io.unobserve(el); });
    figures.forEach(function (el, i) { setTimeout(function () { run(el); }, i * 180); });
  }, { threshold: 0.4 });
  figures.forEach(function (el) { io.observe(el); });
})();
